"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Switch = require("./Switch.styles");

var _Tooltip = _interopRequireWildcard(require("../Tooltip/Tooltip"));

var _icons = require("../../assets/icons");

var _elements = require("../../styles/elements");

/* eslint-disable jsx-a11y/label-has-associated-control */
var Switch = function Switch(_ref) {
  var id = _ref.id,
      children = _ref.children,
      className = _ref.className,
      tooltipTitle = _ref.tooltipTitle,
      tooltipPosition = _ref.tooltipPosition,
      defaultChecked = _ref.defaultChecked,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      value = _ref.value;
  return (0, _jsxRuntime.jsxs)("div", {
    css: _Switch.styles.base,
    className: className,
    children: [(0, _jsxRuntime.jsx)("input", {
      type: "checkbox",
      className: "grui",
      css: _elements.input.styles.preflight,
      id: id,
      disabled: disabled,
      defaultChecked: defaultChecked,
      checked: checked,
      onChange: onChange,
      value: value
    }), (0, _jsxRuntime.jsxs)("label", {
      htmlFor: id,
      children: [(0, _jsxRuntime.jsx)("span", {
        children: (0, _jsxRuntime.jsx)("span", {})
      }), children && (0, _jsxRuntime.jsxs)("div", {
        children: [(0, _jsxRuntime.jsx)("span", {
          className: "grui align-middle",
          children: children
        }), tooltipTitle && (0, _jsxRuntime.jsx)(_Tooltip["default"], {
          position: tooltipPosition,
          title: tooltipTitle,
          children: (0, _jsxRuntime.jsx)(_icons.Question, {
            className: "grui flex-shrink-0 ml-2"
          })
        })]
      })]
    })]
  });
};

Switch.propTypes = {
  id: _propTypes.string.isRequired,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  className: _propTypes.string,
  tooltipTitle: _propTypes.string,
  tooltipPosition: (0, _propTypes.oneOf)(_Tooltip.positions),
  defaultChecked: _propTypes.bool,
  checked: _propTypes.bool,
  disabled: _propTypes.bool,
  onChange: _propTypes.func,
  value: _propTypes.string
};
Switch.defaultProps = {
  children: undefined,
  className: undefined,
  tooltipTitle: undefined,
  tooltipPosition: 'top',
  defaultChecked: undefined,
  checked: undefined,
  disabled: false,
  onChange: function onChange() {},
  value: undefined
};
var _default = Switch;
exports["default"] = _default;
//# sourceMappingURL=Switch.js.map